<template>
  <div class="members">
    <!-- <div style="margin:auto;width:85%"> -->
    <!-- <img src="../assets/all_people.jpg" height="800px" width="1000px" style="margin-top: 10px"> -->


    
    <div class="memory-box">
      <div class="top-bar" style="padding-left: 17px;margin-bottom: 0px;">
        PI
      </div>
      <div v-if="!isMobile"  style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-left: 5%;">
    
        <div style="margin: auto; text-align: left; display: flex">
          <img src="../assets/teacher.jpg" height="320px" width="240px" style="margin-top: 20px;margin-bottom: 20px;">
          <pre style="width: 300px; margin-top: 40px;text-align: left; font-size: 17px; font-family: Arial">
        <b @click="goTeacherPage" class="teacherName" style="font-size: 28px; color: #005BAC; cursor: pointer;text-underline-offset: 10px;">Xiangyu Li (李翔宇) </b>
            <br/>        PhD, Bioinformatics
        Associate Professor
        School of Software Engineering
        Beijing Jiaotong University
        Address:  Room 709, Yifu Building,
                       Beijing Jiaotong University,
                       Beijing 100044, China
        Email: lixiangyu@bjtu.edu.cn
            </pre>

        </div>
      </div>
      <!-- 手机布局 -->
      <div  v-else>
        <div style="margin: auto; text-align: center; display: flex;  flex-direction: column;justify-content: space-evenly;">
          <img src="../assets/teacher.jpg" height="300px" width="225px" style="margin: auto;margin-top: 10px;">
          <pre style="width: 300px; margin-top: 20px;text-align: left; font-size: 16px; font-family: Arial">
  <b @click="goTeacherPage" class="teacherName" style="font-size: 16px; color: #005BAC; cursor: pointer;text-underline-offset: 10px;">Xiangyu Li (李翔宇) </b>
  PhD, Bioinformatics
  Associate Professor
  School of Software Engineering
  Beijing Jiaotong University
  Address:  Room 709, Yifu Building,
                  Beijing Jiaotong University,
                  Beijing 100044, China
  Email: lixiangyu@bjtu.edu.cn
            </pre>

        </div>
      </div>
   
    </div>

    <!-- 给这里加一个边框 -->

    <div  class="memory-box" style=" margin: auto;width: 100%; margin-top: 1%;">
      <div class="top-bar" style="width: 100%;padding-left: 17px; box-sizing: border-box;margin-bottom: 0px;">
        Current Members
      </div>

      <div v-if="!isMobile" class="myGrid">
        <div class="card" style="margin:auto; width:100%;">
      <img src="../assets/xhj.jpg" height="160px" width="120px" style="margin-top: 50px;">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial';">
    <b class="name">Huijie Xue (薛辉杰)</b>
    <br/>    Master Student
    Email:22121756@bjtu.edu.cn
        </pre>
      </div>
      <img src="../assets/wjx.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 300px;text-align: left; margin-top: 50px">
        <pre style="width:300px;font-family: 'Arial'">
    <b class="name">Jinxia Wang (王金霞)</b>
    <br/>    Master Student
    Email:wangjinxia0116@163.com


        </pre>
      </div>
    </div>
    </div>
    <!-- 手机布局 -->
    <div v-else>
            <div class="card" style="margin:auto; width:100%;">
      <img class="studentImg"  src="../assets/xhj.jpg" height="130px" width="97.5px" >
      <div class="studentContent">
        <pre style="width:100%;font-family: 'Arial';">
<b class="name">Huijie Xue (薛辉杰)</b>
Master Student
Email:22121756@bjtu.edu.cn
        </pre>
      </div>
      <img class="studentImg" src="../assets/wjx.jpg" height="130px" width="97.5px">
      <div class="studentContent" >
<pre style="width:400px;font-family: 'Arial'">
<b class="name">Jinxia Wang (王金霞)</b>
Master Student
Email:wangjinxia0116@163.com
        </pre>
      </div>
    </div>

    </div>

    <div   style="border: 1px solid #CCCCCC; width: 90%; margin: auto"></div>
  <div v-if="!isMobile" class="myGrid">

    <div class="card" style="margin:auto; width:100%">
      <img src="../assets/wc_2.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Chen Wang (王琛)</b>
    <br/>    Master Student
    Email:1426822528@qq.com


        </pre>
      </div>
      <img src="../assets/zhangjianxing.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 300px;text-align: left; margin-top: 50px">
        <pre style="width:300px;font-family: 'Arial'">
    <b class="name">Jianxing Zhang (张建兴)</b>
    <br/>    Master Student
    Email:2146015487@qq.com

        </pre>
      </div>
    </div>
      </div>
      <!-- 手机布局  -->
      <div v-else>
        <div class="card" style="margin:auto; width:100%">
      <img class="studentImg" src="../assets/wc_2.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
<b class="name">Chen Wang (王琛)</b>
Master Student
Email:1426822528@qq.com
        </pre>
      </div>
      <img class="studentImg" src="../assets/zhangjianxing.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:300px;font-family: 'Arial'">
<b class="name">Jianxing Zhang (张建兴)</b>
Master Student
Email:2146015487@qq.com
        </pre>
      </div>
    </div>
      </div>
      <div style="border: 2px solid #CCCCCC; width: 90%; margin: auto"></div>
      <div v-if="!isMobile" class="myGrid" style="margin: auto;">
       
    <div class="card" style="margin:auto; width:100%">
      <img src="../assets/yaozhuoxing.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Zhuoxin Yao (姚卓鑫)</b>
    <br/>    Master Student
    Email:2362063568@qq.com
        </pre>
      </div>
      <img src="../assets/zhaorui.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 300px;text-align: left; margin-top: 50px">
        <pre style="width:400px;;font-family: 'Arial'">
    <b class="name">Rui Zhao (赵蕊)</b>
    <br/>    Master Student
    Email:1836162874@qq.com
        </pre>
      </div>
    </div>


        
      </div>
      <div v-else>
        <div class="card" style="margin:auto; width:100%">
      <img class="studentImg" src="../assets/yaozhuoxing.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
<b class="name">Zhuoxin Yao (姚卓鑫)</b>
Master Student
Email:2362063568@qq.com
        </pre>
      </div>
      <img class="studentImg" src="../assets/zhaorui.jpg" height="130px" width="97.5px">
      <div class="studentContent">
<pre style="width:400px;;font-family: 'Arial'">
<b class="name">Rui Zhao (赵蕊)</b>
Master Student
Email:1836162874@qq.com
        </pre>
      </div>
    </div>
      </div>
      
      <div style="border: 1px solid #CCCCCC; width: 90%; margin: auto"></div>
      <div v-if="!isMobile" class="myGridlcc">
       
        
    <div style="display: flex; margin:auto; width: 100%; height: 300px">
      <img src="../assets/lcc.jpg" height="160px" width="120px" style="margin-top: 70px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Chengcheng Liu (刘铖铖)</b>
    <br/>    PhD Student
    University of Texas at Dallas
    Email:chengcheng.liu@utdallas.edu
    Joint Ph.D. Student with UT Dallas
        </pre>
      </div>
    </div>
      </div>

      <div v-else>
        <div style="padding-top: 10px; width:100%">
      <img class="studentImg" src="../assets/lcc.jpg" height="130px" width="97.5px" style="margin: 0px auto;">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
<b class="name">Chengcheng Liu (刘铖铖)</b>
PhD Student
University of Texas at Dallas
Email:chengcheng.liu@utdallas.edu
Joint Ph.D. Student with UT Dallas
        </pre>
      </div>
    </div>
      </div>
    </div>



    <div class="memory-box" style=" margin: auto;width: 100%; margin-top: 1%;">
      <div class="top-bar" style="width: 100%;padding-left: 17px; box-sizing: border-box;margin-bottom: 0px;">
        Alumni
      </div>

      <div v-if="!isMobile" class="myGrid">
        <div class="card" style="margin:auto; width:100%">
      <img src="../assets/hyy.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Yuying Huo (霍玉莹)</b>
    <br/>    Master (2021.9 -2024.7)
    Email:760256235@qq.com
    Current:PhD student at Peking U.
<!--    -->
        </pre>
      </div>
      <img src="../assets/wjk.png" height="160px" width="120px"  style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 300px;text-align: left; margin-top: 50px">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Jiakang Wang (王嘉康)</b>
    <br/>    Master (2022.9 -2024.7)
    Email:wangjiakang0116@163.com
    Current:National Immigration
    Administration (国家移民管理局)
        </pre>
      </div>
    </div>
      </div>


      <!-- 手机布局 -->
      <div v-else>
        <div>
      <img class="studentImg" src="../assets/hyy.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
<b class="name">Yuying Huo (霍玉莹)</b>
Master (2021.9 -2024.7)
Email:760256235@qq.com
Current:PhD student at Peking U.
        </pre>
      </div>
      <img class="studentImg" src="../assets/wjk.png" height="130px" width="97.5px" >
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
<b class="name">Jiakang Wang (王嘉康)</b>
Master (2022.9 -2024.7)
Email:wangjinxia0116@163.com
Current:National Immigration
Administration (国家移民管理局)
        </pre>
      </div>
    </div>
      </div>


    <div style="border: 2px solid #CCCCCC; width: 90%; margin: auto"></div>

      <div v-if="!isMobile" class="myGrid">
        <div style="display: flex; margin:auto; width: 100%; height: 300px">
      <img src="../assets/gmn.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 350px;text-align: left; margin-top: 30px">
        <pre style="width:400px;font-family: 'Arial'; margin-left: -10px">
   <b class="name">Mengnan Gao (高梦楠)</b>
    <br/>    Master (2022.9 -2024.7)
    Email:1419524957@qq.com
    Current:Hebei Branch of China
    Telecom Corporation Limited
    (中国电信股份有限公司河北分公司)

        </pre>
      </div>
      <img src="../assets/gyl.jpg" height="160px" width="120px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 300px;text-align: left; margin-top: 30px">
        <pre style="width:400px;font-family: 'Arial'; margin-left: -10px">
   <b class="name">Yilang Guo (郭奕朗)</b>
    <br/>    Undergraduate
    Email:guoyilang@buaa.edu.cn
    Current:Master Student at Beihang U.
          <!--    -->
        </pre>
      </div>
    </div>
      </div>
      <!-- 手机布局 -->
      <div v-else>
        <div>
      <img class="studentImg" src="../assets/gmn.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial';">
<b class="name">Mengnan Gao (高梦楠)</b>
Master (2022.9 -2024.7)
Email:1419524957@qq.com
Current:Hebei Branch of China
Telecom Corporation Limited
(中国电信股份有限公司河北分公司)
        </pre>
      </div>
      <img class="studentImg" src="../assets/gyl.jpg" height="130px" width="97.5px" >
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial';">
<b class="name">Yilang Guo (郭奕朗)</b>
Undergraduate
Email:guoyilang@buaa.edu.cn
Current:Master Student at Beihang U.
        </pre>
      </div>
    </div>
      </div>



    </div>


  

    <div class="memory-box" style=" margin: auto;width: 100%; margin-top: 1%;">
      <div class="top-bar" style="width: 100%;padding-left: 17px; box-sizing: border-box;margin-bottom: 0px;">
        Collaborators
      </div>
      <div v-if="!isMobile" class="myGrid" style="margin-left: 27px;">
        <div class="card" style="margin:auto; width:100%">
      <img src="../assets/gtt.jpg" height="200px" width="150px" style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 340px;text-align: left; margin-top: 17px">
        <pre style="width:400px;font-family: 'Arial'">
   <b class="name">Tiantian Guo (郭甜甜)</b>
    Tsinghua University
    Email:576289054@qq.com
    Postdoc.,Tsinghua U.(2023.7-now)
    Ph.D., Tsinghua U. (2018.9-2023.6)
    Master.,Tsinghua U.(2015.9-2018.7)
    B.Eng.,UESTC (2011.9-2015.7) 
<!--    postcode:--> 
        </pre>
      </div>
      <img src="../assets/wh.jpg" height="200px" width="150px"  style="margin-top: 50px">
      <div style="font-size: 17px;font-family: 'Arial'; width: 370px;text-align: left; margin-top: 17px">
        <pre style="width:400px;font-family: 'Arial'">
   <b class="name">Han Wang (王涵)</b>
    China Agricultural University
    Email:wanghanjida@163.com
    Associate Prof.,
    China Argicultural U.(2023.12-now)
    Postdoc.,HongKong U.(2021.8-2023.8)
    Ph.D.,Peking U.(2015.9-2021.7)
    B.S.,Jilin U.(2011.9-2015.7)
<!--    postcode:-->
        </pre>
      </div>
    </div>
      </div>
      <!-- 手机布局 -->
      <div v-else>
        <div >
      <img class="studentImg" src="../assets/gtt.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Tiantian Guo (郭甜甜)</b>
Tsinghua University
Email:576289054@qq.com
Postdoc.,Tsinghua U.(2023.7-)
Ph.D., Tsinghua U. (2018.9-2023.6)
Master.,Tsinghua U.(2015.9-2018.7)
B.Eng.,UESTC (2011.9-2015.7) 
        </pre>
      </div>
      <img class="studentImg" src="../assets/wh.jpg" height="130px" width="97.5px">
      <div class="studentContent">
        <pre style="width:400px;font-family: 'Arial'">
    <b class="name">Han Wang (王涵)</b>
China Agricultural University
Email:wanghanjida@163.com
Associate Prof.,China Argicultural U.
(2023.12-)
Postdoc.,HongKong U.(2021.8-2023.8)
Ph.D.,Peking U.(2015.9-2021.7)
B.S.,Jilin U.(2011.9-2015.7)
        </pre>
      </div>
    </div>
      </div>


    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      isMobile: false,
    }
  },
  name: 'People',
  methods: {
    checkScreenSize() {
      // 判断屏幕宽度是否小于768px
      this.isMobile = window.innerWidth < 768;
    },
    goTeacherPage () {
      this.$router.push({ path: '/Teacher' })
    }
  },
  mounted() {
    // 初始化屏幕宽度检测
    this.checkScreenSize();
    // 监听窗口大小变化
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.checkScreenSize);
  },
}
</script>

<style scoped>


.titles {
  color: #005BAC;
  text-align: left;
  margin: 17px 0 0 0;
  padding: 0;
}
.wantClickCss :hover {
  cursor: pointer;
  color: blue;
}
.card{
   font-size: 17px;
   display: flex;
  height: 300px;
 }
 /* 框的样式 */
.memory-box {
  border-radius: 0px;
  margin-top: 20px;
  flex-direction: column; /* 垂直排列子元素 */
  justify-content: flex-start; /* 子元素从顶部开始排列 */
  border: 2px solid #005BAC;
  padding: 200px;
  width: auto;  /* 调整框宽度 */
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中 */          
  /* border-radius: 10px; */
  padding: 0px;
  margin: auto;
  width: 100%; 
  margin-top: 1%;
  }
.top-bar {
  padding: 0px;
  font-size: 28px;
  width: 100%;
  /* height: 32px; */
  background-color: #005BAC; /* 背景色 */
  color: white;
  text-align: left;
  /* line-height: 32px; 垂直居中文本 */
  margin-bottom: 10px; /* 与下方的内容之间留出间距 */
  width: 100%;
  box-sizing: border-box;
}

.myGridlcc {
  display: grid; 
  grid-template-columns: 1fr 1fr; 
  gap: 17px; 
  margin-left: 55px;
}

.myGrid {
  display: grid; 
  grid-template-columns: 50% 50%; 
  gap: 0px; 
  margin-left: 0px;
}
.name{
  font-size:25px; 
  color: #005BAC; 
  padding: 5px;
}
.teacherName:hover{
  text-decoration: underline;
}
.members{
  margin:auto;
  width: 1000px;
}

@media (max-width: 768px) {
  .members{
    margin:auto;
    width: 90%;
  }
  .top-bar{
    padding-left: 0px;
    margin-left: 0px;
    font-size: 20px;
  }

  .card{
    padding-top: 10px;
   font-size: 17px;
   display: flex;
  height: 500px;
  flex-direction: column;
 }
 .name{
  font-size:20px; 
  color: #005BAC;
 }
 .studentImg{
  margin: auto;
 }
 .studentContent{
  font-size: 16px;
  font-family: 'Arial'; 
  width: 400px;
  text-align: center; 
  margin-bottom: 0px;
  margin-top: 0px
 }
 pre{
  margin-bottom: 0px;
  margin-top: 0px
 }
}
</style>



// WEBPACK FOOTER //
// src/components2/People.vue